// @flow
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import styled from 'styled-components';
import { withWhiteLabel } from '../WhiteLabelProvider';

import { Content, Title, P, Anchor, LinkButton } from './components';

import AcceptTermsDialog from './Signup/AcceptTermsDialog';
import ParkChicagoLogo from '../assets/park-chicago-logo';
import PoweredByPassport from '../assets/icons/powered-by-passport-svg';

import ReactGA from 'react-ga';

const DIALOG_TERMS = 'DIALOG_TERMS';

const FooterLink = styled(Anchor)`
  font-size: 0.75em;
  margin: 0 2em;
`;

const FooterLogo = styled.div`
  display: block;
  margin: 12em auto 1em;
`;

type Props = {
  name: string,
  termsUrl: string,
  privacyUrl: string,
};

type State = {
  activeDialog: null | typeof DIALOG_TERMS,
  redirect: null | true,
};

// we export the Welcome class for testing purposes
export class Welcome extends Component<Props, State> {
  state = {
    activeDialog: null,
    redirect: null,
  };

  closeModals = (e: SyntheticEvent<HTMLElement>) => {
    this.sendPageEvent(e);
    // GOOGLE ANALYTICS: welcome_signup_decline
    ReactGA.event({
      category: 'Welcome',
      action: 'User clicks "Decline" button in Sign Up Modal',
      label: 'Sign Up Decline',
    });
    this.setState({ activeDialog: null });
  };

  onAcceptTerms = (e: SyntheticEvent<HTMLElement>) => {
    this.sendPageEvent(e);
    // GOOGLE ANALYTICS: welcome_signup_accept
    ReactGA.event({
      category: 'Welcome',
      action: 'User clicks "Accept" button in Sign Up Modal',
      label: 'Sign Up Accept',
    });
    this.setState({ activeDialog: null, redirect: true });
  };

  handleSignupClick = (e: SyntheticEvent<HTMLElement>) => {
    e.preventDefault();
    this.sendPageEvent(e);
    this.setState({ activeDialog: DIALOG_TERMS });
  };

  sendPageEvent = (e: SyntheticEvent<HTMLElement>) => {
    let eventType = e.target.textContent;
    switch (eventType) {
      // GOOGLE ANALYTICS: welcome_signup
      case 'Sign Up':
        ReactGA.event({
          category: 'Welcome',
          action: 'User clicks "Sign Up" button',
          label: 'Sign Up',
        });
        break;
      // GOOGLE ANALYTICS: welcome_login
      case 'Log In':
        ReactGA.event({
          category: 'Welcome',
          action: 'User clicks "Log In" button',
          label: 'Log In',
        });
        break;
      // GOOGLE ANALYTICS: welcome_terms
      case 'Terms and Conditions':
        ReactGA.event({
          category: 'Welcome',
          action: 'User clicks "Terms and Conditions"',
          label: 'Terms & Conditions',
        });
        break;
      // GOOGLE ANALYTICS: welcome_privacy
      case 'Privacy Policy':
        ReactGA.event({
          category: 'Welcome',
          action: 'User clicks "Privacy Policy"',
          label: 'Privacy Policy',
        });
        break;
    }
  };

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          push
          to={{
            pathname: '/signup',
            state: { acceptedTerms: true },
          }}
        />
      );
    }

    const { name, termsUrl, privacyUrl } = this.props;

    return [
      <Content key="content">
        <ParkChicagoLogo />
        <Title>{`Welcome to ${name} Fleet`}</Title>
        <P>
          {name} Fleet requires company / fleet information as well as a $20.00
          pre-loaded fleet wallet balance to cover expenses. By proceeding you
          agree that your balance will incur a replenishment charge once it
          reaches or goes below $0.00. If charges fail, your fleet will not be
          able to park when your balance reaches a $0.00 minimum.
        </P>
        <LinkButton to="/signup" onClick={this.handleSignupClick}>
          {'Sign Up'}
        </LinkButton>
        <LinkButton
          to="/login"
          onClick={this.sendPageEvent}
          variant="secondary">
          {'Log In'}
        </LinkButton>
        <FooterLink href={termsUrl} onClick={this.sendPageEvent}>
          {'Terms and Conditions'}
        </FooterLink>
        <FooterLink href={privacyUrl} onClick={this.sendPageEvent}>
          {'Privacy Policy'}
        </FooterLink>
        <FooterLogo>
          <PoweredByPassport />
        </FooterLogo>
      </Content>,

      this.state.activeDialog === DIALOG_TERMS && (
        <AcceptTermsDialog
          key="dialog"
          onClose={this.closeModals}
          onAccept={this.onAcceptTerms}
          onDecline={this.closeModals}
        />
      ),
    ];
  }
}

export default withWhiteLabel(({ settings }) => (
  <Welcome
    name={settings.displayname}
    termsUrl={settings.termsUrl}
    privacyUrl={settings.privacyUrl}
  />
));



// WEBPACK FOOTER //
// ./src/Auth/Welcome.js